export default {
    modal: {
        header: {
            text: "Account Details",
            waivedInterestPromotion: "Waived Interest Promotion",
        },
        footer: {
            closeButton: "Close",
            backButton: "BACK",
        },
    },
    drawerHeader: {
        title: "SetPay Account",
        subtitle: {
            account: "Account ending in {{accountLast4}}",
            loan: "Loan ending in {{accountLast4}}",
        },
    },
    grid: {
        month: "month",
        months: "months",
        meter: "Paid Off",
        creditMeter: "Credit Used",
        meterPN4: "Payments Made",
        loanAmount: "Loan Amount",
        loanMaturityDate: "Loan Maturity Date",
        amountFinanced: "Amount Financed",
        totalLoanBalance: "Total Loan Balance",
        totalDue: "Total Due",
        totalLoanBalanceTooltip: "The Total Loan Balance may change for various reasons (e.g. charges, fees, payments, and returns). If applicable, the Total Loan Balance may increase as items are fulfilled.",
        securedInstallmentTotalLoanBalanceTooltip: "This is the remaining principal balance still owed on your loan. It is not the amount required to pay the loan in full. To get a current payoff quote please call our Customer Service team at <helpNumber/>.",
        totalDueTooltip: "Includes any fees and past due amounts.",
        autopayStatusTooltip: "To manage your autopay settings call <helpNumber/>.",
        purchaseAmount: "Purchase Amount",
        totalRemaining: "Total Remaining",
        totalPaid: "Total Paid",
        creditLimit: "Credit Limit",
        currentBalance: "Current Balance",
        statementBalance: "Statement Balance",
        availableToSpend: "Available to Spend",
        availableToSpendTooltip: "May not reflect recent transactions.",
        promotionStatusTooltip: {
            active: "This loan is within the Waived Interest promotional period.",
            expired: "This loan is outside of the Waived Interest promotional period and is no longer eligible to have all interest waived.",
        },
        titles: {
            accountInformation: "Account Information",
            payments: "Payments",
            paymentInformation: "Payment Information",
            loanSummary: "Loan Summary",
            loanDetails: "Loan Details",
            loanInformation: "Loan Information",
            paymentSchedule: "Payment Schedule",
        },
        labels: {
            feesChargedYearToDate: "Total Fees Charged YTD",
            interestChargedYearToDate: "Total Interest Charged YTD",
            purchaseAPR: "Purchase APR",
            cashAdvanceLimit: "Cash Advance Limit",
            cashAdvanceAPR: "Cash Advance APR",
            currentBalance: "Current Balance",
            lastStatementBalance: "Last Statement Balance",
            newPurchases: "New Purchases",
            nextPaymentDate: "Next Payment Due Date",
            totalMinimumPaymentDue: "Total Minimum Payment Due",
            lastPaymentDate: "Last Payment Date",
            lastPaymentAmount: "Last Payment Amount",
            outstandingFeesAndCharges: "Outstanding Fees and Charges",
            pastDueAmount: "Past Due Amount",
            currentInterestRate: "Current Interest Rate",
            autoPayStatus: {
                on: "On",
                off: "Off",
                text: "Autopay Status",
            },
            principalPaid: "Principal Paid",
            interestPaid: "Interest Paid",
            purchaseAmount: "Purchase Amount",
            purchaseDate: "Purchase Date",
            monthlyLoanPayment: "Monthly Loan Payment",
            monthlyPayment: "Monthly Payment",
            loanAmount: "Loan Amount",
            loanStartDate: "Loan Start Date",
            loanEndDate: "Loan End Date",
            promotionalPeriodEnds: "Promotional Period Ends",
            introPeriodEnds: "Intro Period Ends",
            introPeriodEnded: "Intro Period Ended",
            promotionalPeriod: "Promotional Period",
            interestRate: "Interest Rate",
            activeIntroRateLoanInformationTooltip: "Your loan has an intro rate with a set payment. Your rate and payment amount will increase when the intro period ends.",
            expiredIntroRateLoanInformationTooltip: "Your loan's intro rate period had a set rate and payment has ended. Your rate and payment amount increased when the intro period ended.",
            introRateLoanMonthlyPayment: "{{promoLoanTerm}} Month Intro Rate Period",
            postIntroLoanMonthlyPayment: "{{postLoanTerm}} Month Post Intro Rate Period",
            introPeriodRate: "Intro Period Rate",
            introPeriodStatus: "Intro Period Status",
            introPeriodExpirationDate: "Intro Period End Date",
            postIntroRate: "Post Intro Rate",
            loanTerm: "Loan Term",
            termRemaining: "Term Remaining",
            estimatedPayoffAmount: "Estimated Payoff Amount",
            estimatedPayoffAmountTooltip: "Estimated payoff amount is good for today only.",
            activePromoStatusTooltip: "This loan is within the intro period. You have a lower rate.",
            expiredPromoStatusTooltip: "The intro period has expired. Your rate has increased.",
            scheduledLoanPayment: "Scheduled Loan Payment",
            nextAmountDue: "Next Amount Due",
            nextAmountMothlyTooltip: "Includes any fees and past due amounts.",
            nextAmountPN4Tooltip: "Includes any past due amounts.",
            paymentNumberOfTotal: "Payment {{n, number}} of {{total, number}}",
            paymentAmount: "Payment Amount",
            scheduledPaymentAmount: "Scheduled Payment Amount",
            nextScheduledPaymentAmount: "Next Scheduled Payment Amount",
            nextScheduledPaymentDate: "Next Scheduled Payment Date",
            promoExpirationDate: "Promotional Expiration Date",
            promotionalBalance: "Promotional Balance",
            promotionStatus: {
                active: "Active",
                expired: "Expired",
                text: "Promotion Status",
            },
        },
        accountNotice: "Amounts may not reflect recent activity.",
        accountNoticePN4: "Amounts and end date may not reflect recent activity.",
        accountNoticeSecuredInstallmentLoan: "This is an attempt to collect a debt and any information obtained will be used for that purpose.",
    },
    error: {
        api: {
            title: "Account Details Unavailable",
        },
        default: {
            title: "Sorry, there was an unexpected problem!",
            subtitle: "We're having trouble retrieving this information. Please reload the page or try again later.",
        },
        uiComponent: "Unavailable",
    },
    waivedInterest: {
        days: "days",
        heading: " What is an installment loan with waived interest?",
        bold: {
            first: "all the interest is waived if you pay it off before the end of the promotional period.",
            second: "  There is no pre-payment penalty.",
        },
        first: "An installment loan with waived interest if paid in full within the promotional period, ",
        second: " It is a one-time use loan that closes when paid in full. The loan has a fixed APR, fixed term, and monthly payments.",
        third: "If you pay off your amount financed plus any assessed fees before the end of the promotional period, all interest will be waived.",
        fourth: "If you do not pay the amount financed plus any assessed fees before the end of the promotional period, interest will be charged up to the full loan term.",
        promoEndDate: "Pay off your loan balance including fees by {{promoEndDate}} to waive interest.",
        expiredPromoEndDate: "This loan is outside of the Waived Interest promotional period.",
    },
    introRateLoan: {
        activeIntroLoanDetails: "Tip: pay off or pay more during your intro rate to reduce interest paid over the life of the loan.",
        expiredIntroLoanDetails: "Your intro rate has ended.",
        introStatusActive: "Active",
        introStatusExpired: "Expired",
    },
    sandbox: {
        dashboard: {
            viewDetails: "View Details",
            accountEndingIn: "Account ending in",
            loanEndingIn: "Loan ending in",
        },
    },
};
//# sourceMappingURL=en.js.map